import { render, staticRenderFns } from "./DoctorMaleIcon.vue?vue&type=template&id=b738fc9e"
import script from "./DoctorMaleIcon.vue?vue&type=script&lang=js"
export * from "./DoctorMaleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports